import { useTranslation } from 'react-i18next';
import { ConstellationDivider } from 'shared/components/ConstellationDivider';
import { PageHeader } from 'shared/components/PageHeader';
import { useScrollReveal } from 'shared/hooks/useScrollReveal';

export const HeroSection = () => {
  const { t } = useTranslation('about');
  const image = useScrollReveal({ animation: 'fade-image' });
  // const quote = useScrollReveal({ animation: 'float-up', delay: 360 });

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 mb-16 md:mb-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center pt-8">
      <div className="lg:col-span-7 lg:pr-8 z-10">
        <PageHeader
          label={t('hero.label')}
          title={t('hero.title')}
          titleHighlight={t('hero.highlight')}
          description={t('hero.description')}
          italic
        >
          <ConstellationDivider className="mt-12" />
        </PageHeader>
      </div>

      <div ref={image.ref} style={image.style} className="lg:col-span-5 relative">
        <div className="aspect-[4/5] bg-surface-container-low rounded-xl relative shadow-2xl sm:max-w-[450px] mx-6 sm:m-auto lg:m-none">
          <img
            src="/images/cider.jpg"
            alt={t('hero.imageAlt')}
            className="w-full h-full object-cover opacity-90 dark:mix-blend-lighten rounded-xl"
          />
          {/* <div
            ref={quote.ref}
            style={quote.style}
            className="absolute -bottom-24 sm:-bottom-8 -left-8 bg-surface-bright p-8 rounded-xl shadow-xl max-w-[280px]"
          >
            <p className="font-serif italic text-lg text-on-surface">
              {QUOTE_TEXT}
            </p>
          </div> */}
        </div>
      </div>
    </section>
  )
}
